import { Icon, IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react'
import { Pencil } from 'lucide-react'

interface Props extends Omit<IconButtonProps, 'aria-label'> {}

const Component = ({ isLoading, onClick, ...props }: Props) => {
  return (
    <Tooltip label="Editar">
      <IconButton
        colorScheme="primary"
        aria-label="Editar"
        isLoading={isLoading}
        onClick={onClick}
        icon={<Icon as={Pencil} />}
        {...props}
      />
    </Tooltip>
  )
}

export default Component
